import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import './Classify.scss'
import { api } from 'common/app'

class Classify extends React.Component {
  constructor (props) {
    super(props)
    // this.state = {
    //   List: []
    // }
  }
  render () {
    return <div className='Classify'>
      <img src={this.props.msg.msgIndex== 0 ? require('./images/yes.png'):require('./images/icon@2x.png')}/>
      <p>{this.props.msg.text}</p>
    </div>
  }
}

// Classify.propTypes = {
//   close: PropTypes.func.isRequired,
//   change: PropTypes.func.isRequired
// }

export default Classify



// WEBPACK FOOTER //
// ./src/routes/home/components/Classify/index.js